import { JsonObject, JsonProperty } from 'json2typescript'
import DateConverter from '@/converters/DateConverter'

@JsonObject('VehicleClaimValue')
export default class VehicleClaim {
  @JsonProperty('faultClaim', Boolean)
  faultClaim: boolean | null = null

  @JsonProperty('claimDate', DateConverter, true)
  claimDate: Date | null = null

  @JsonProperty('claimType', String)
  claimType: string | null = null

  @JsonProperty('claimAmount', Number, true)
  claimAmount: number | null = null
}
